(() => {
  const config = document.querySelector('[data-vh-language]');
  if (!config) return;
  const current = config.dataset.current;
  const available = config.dataset.languages.split(',');
  const key = 'vh-language';
  let saved;
  try { saved = localStorage.getItem(key); } catch {}
  const remember = value => { try { localStorage.setItem(key, value); } catch {} };
  document.addEventListener('change', event => {
    if (event.target.matches('[name="language_code"], [name="locale_code"]') && available.includes(event.target.value)) remember(event.target.value);
  }, true);
  document.addEventListener('submit', event => {
    if (event.target.id === 'VelberterAutoLanguage') return;
    const input = event.target.querySelector('[name="language_code"], [name="locale_code"]');
    if (input && available.includes(input.value)) remember(input.value);
  }, true);
  if (/bot|crawler|spider/i.test(navigator.userAgent)) return;
  const explicit = available.some(locale => locale !== 'de' && (location.pathname === '/' + locale || location.pathname.startsWith('/' + locale + '/')));
  if (explicit) { remember(current); return; }
  let attempted;
  try { attempted = sessionStorage.getItem('vh-language-attempt'); } catch {}
  const preferred = (navigator.languages || [navigator.language]).map(code => code.toLowerCase().split('-')[0]).find(code => available.includes(code)) || 'de';
  const target = available.includes(saved) ? saved : preferred;
  if (target === current || attempted === target) { if (!saved) remember(current); return; }
  try { sessionStorage.setItem('vh-language-attempt', target); } catch {}
  remember(target);
  const form = document.getElementById('VelberterAutoLanguage');
  form.elements.language_code.value = target;
  form.submit();
})();
